"use strict";
exports.__esModule = true;
exports.closeAccountSelect = exports.openAccountSelect = exports.selectAccount = void 0;
var streams_1 = require("./streams");
var selectAccount = function (account) { return streams_1.accounts$.next([account]); };
exports.selectAccount = selectAccount;
var openAccountSelect = function () {
    return streams_1.selectAccounts$.next({
        inProgress: true
    });
};
exports.openAccountSelect = openAccountSelect;
var closeAccountSelect = function () {
    return streams_1.selectAccounts$.next({
        inProgress: false
    });
};
exports.closeAccountSelect = closeAccountSelect;
